/** События для связи тура редактора с 3D (насос в техпомещении). */
export const EDITOR_ONBOARDING_PUMP_TOOLTIP_OPEN = 'welland:editor-onboarding-open-glong-pump-tooltip';
export const EDITOR_ONBOARDING_PUMP_TOOLTIP_CLOSE = 'welland:editor-onboarding-close-pump-tooltip';
/** Полный сброс захвата сцены обучалкой (тултип, таймеры). */
export const EDITOR_ONBOARDING_SCENE_RELEASE = 'welland:editor-onboarding-scene-release';
